export enum Permiso {

    /* #region Administracion */
    ConsultarAdministracion = "1",
    /* #endregion */

    /* #region Tablero */
    ConsultarTablero = "2",
    /* #endregion */

    /* #region Modulos */
    AgregarModulo = "3",
    ActualizarModulo = "4",
    ConsultarModulos = "5",
    EliminarModulo = "6",
    /* #endregion */

    /* #region Permisos */
    AgregarPermiso = "7",
    ActualizarPermiso = "8",
    ConsultarPermisos = "9",
    EliminarPermiso = "10",
    /* #endregion */

    /* #region Bitacora */
    ConsultarBitacora = "11",
    /* #endregion */

    /* #region Familias */
    AgregarFamilia = "12",
    ActualizarFamilia = "13",
    ConsultarFamilias = "14",
    EliminarFamilia = "15",
    /* #endregion */

    /* #region Subfamilias */
    AgregarSubfamilia = "16",
    ActualizarSubfamilia = "17",
    ConsultarSubfamilias = "18",
    EliminarSubfamilia = "19",
    /* #endregion */

    /* #region Proveedores */
    AgregarProveedor = "20",
    ActualizarProveedor = "21",
    ConsultarProveedores = "22",
    EliminarProveedor = "23",
    /* #endregion */

    /* #region Presentaciones */
    AgregarPresentacion = "24",
    ActualizarPresentacion = "25",
    ConsultarPresentaciones = "26",
    EliminarPresentacion = "27",
    /* #endregion */

    /* #region Tipo Producto */
    AgregarTipoProducto = "28",
    ActualizarTipoProducto = "29",
    ConsultarTipoProductos = "30",
    EliminarTipoProducto = "31",
    /* #endregion */

    /* #region Clientes */
    AgregarCliente = "32",
    ActualizarCliente = "33",
    ConsultarClientes = "34",
    EliminarCliente = "35",
    /* #endregion */

    /* #region Usuarios */
    AgregarUsuario = "36",
    ActualizarUsuario = "37",
    ConsultarUsuarios = "38",
    EliminarUsuario = "39",
    /* #endregion */

    /* #region Roles */
    AgregarRol = "40",
    ActualizarRol = "41",
    ConsultarRoles = "42",
    EliminarRol = "43",
    /* #endregion */

    /* #region Entidades */
    ConsultarEntidades = "44",
    /* #endregion */

    /* #region Cadena */
    AgregarCadena = "45",
    ActualizarCadena = "46",
    ConsultarCadenas = "47",
    EliminarCadena = "48",
    /* #endregion */

    /* #region Sucursal */
    AgregarSucursal = "49",
    ActualizarSucursal = "50",
    ConsultarSucursales = "51",
    EliminarSucursales = "52",
    /* #endregion */

    /* #region Caja */
    AgregarCaja = "53",
    ActualizarCaja = "54",
    ConsultarCajas = "55",
    EliminarCaja = "56",
    /* #endregion */

    /* #region Productos */
    AgregarProducto = "57",
    ActualizarProducto = "58",
    ConsultarProductos = "59",
    EliminarProducto = "60",
    /* #endregion */

    /* #region Inventario */
    SincronizarInventario = "61",
    ConsultarInventario = "62",
    ConsultarCompras = "116",
    ConsultarSalidas = "117",
    ConsultarTraspasos = "118",
    ConsultarHistorialTraspasos = "119",
    ConsultarKardex = "120",
    ConsultarAjustes = "121",
    AgregarAjuste = "122",
    /* #endregion */

    /* #region KashPOS */
    ConsultarKashPOS = "63",
    /* #endregion */

    /* #region Cierre */
    ConsultarCierre = "64",
    /* #endregion */

    /* #region Tickets Cerrados */
    ConsultarTicketsCerrados = "65",
    /* #endregion */

    /* #region Marcas */
    AgregarMarca = "70",
    ActualizarMarca = "71",
    ConsultarMarcas = "72",
    EliminarMarca = "73",
    /* #endregion */

}
